import http from "@/axios/http-common";

const BASE = "/lab/critical-result";

export default {
  // Master data
  getThresholds(params?: any) {
    return http.getDataParam(`${BASE}/thresholds`, { params });
  },
  getReasonDefinitions() {
    return http.getData(`${BASE}/reason-definitions`);
  },
  evaluateThreshold(data: any) {
    return http.postData(`${BASE}/thresholds/evaluate`, data);
  },

  // LIS candidates (tarik hasil kritis dari LIS, tanpa entri manual)
  getLisCandidates(params?: any) {
    return http.getDataParam(`${BASE}/lis-candidates`, { params });
  },

  // Events CRUD
  getEvents(params?: any) {
    return http.getDataParam(`${BASE}/events`, { params });
  },
  getEvent(id: number) {
    return http.getData(`${BASE}/events/${id}`);
  },
  createEvent(data: any) {
    return http.postData(`${BASE}/events`, data);
  },
  updateEvent(id: number, data: any) {
    return http.putData(`${BASE}/events/${id}`, data);
  },
  deleteEvent(id: number) {
    return http.deleteData(`${BASE}/events/${id}`);
  },
  getDailyCapaian(id: number) {
    return http.getData(`${BASE}/events/${id}/daily-capaian`);
  },

  // Acknowledge
  acknowledgeEvent(id: number, data: any) {
    return http.postData(`${BASE}/events/${id}/acknowledge`, data);
  },

  // RCA
  getRcaItems(eventId: number) {
    return http.getData(`${BASE}/events/${eventId}/rca`);
  },
  createRcaItems(eventId: number, data: any) {
    return http.postData(`${BASE}/events/${eventId}/rca`, data);
  },
  updateRcaItem(id: number, data: any) {
    return http.putData(`${BASE}/rca/${id}`, data);
  },
  deleteRcaItem(id: number) {
    return http.deleteData(`${BASE}/rca/${id}`);
  },

  // Signing
  signEvent(id: number, data: any) {
    return http.putData(`${BASE}/events/${id}/sign`, data);
  },

  // PDF
  getPdfUrl(id: number): string {
    return `${BASE}/events/${id}/pdf`;
  },

  // Reports
  getPeriodicReports(params?: any) {
    return http.getDataParam(`${BASE}/reports/periodic`, { params });
  },
  generateDailyReport(data: any) {
    return http.postData(`${BASE}/reports/generate-daily`, data);
  },
  generateMonthlyReport(data: any) {
    return http.postData(`${BASE}/reports/generate-monthly`, data);
  },
  getAllPeriods(params: any) {
    return http.getDataParam(`${BASE}/reports/all-periods`, { params });
  },
  getPareto(params: any) {
    return http.getDataParam(`${BASE}/reports/pareto`, { params });
  },

  // Dashboard
  getDashboard(params?: any) {
    return http.getDataParam(`${BASE}/dashboard`, { params });
  },
};
